import React, { useState } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';

const Accordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className='cssOne' style={{ 
        // marginLeft: '200px',
        // marginRight: '200px'
        // width: '300px', 
        // margin: '0 auto' 
        }}>
      {items.map((item, index) => (
        <div key={index} 
        // style={{ marginBottom: '10px' }}
        >
          <div
            style={{
              display: 'flex',
            //   justifyContent: 'space-between',
                gap:'16px',
              alignItems: 'center',
              cursor: 'pointer',
            //   backgroundColor: '#f1f1f1',
              padding: '10px',
            }}
            onClick={() => handleClick(index)}
          >
            {activeIndex === index ? <FaTimes /> : <FaPlus />}
            <h3 className='headingtext1' style={{ margin: 0 }}>{item.title}</h3>
          </div>
          {activeIndex === index && (
            <div className='headingtext2' style={{ padding: '10px', marginLeft: '34px'
            //  backgroundColor: '#e9ecef' 
             }}>
              {item.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
